import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

/**
 * Makes one agent take its next turn immediately. Returns
 * `{ forced, simulationId, agentConversationId, reason }`. `forced: false` with
 * a `reason` is a normal outcome (e.g. the simulation isn't running, or a
 * previous request is still pending) — not an error. Never blocks or queues.
 */
const forceSimulationAgentTick = (
  simulationId,
  agentConversationId,
  callback,
  errorCallback,
) => {
  return async (dispatch) => {
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.post(
            `/ads/admin/simulations/${simulationId}/agents/${agentConversationId}/force-tick`,
            null,
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            if (typeof callback === 'function') callback(response?.data);
          } else {
            if (typeof errorCallback === 'function')
              errorCallback('Failed to force a tick');
          }
        } catch (e) {
          if (typeof errorCallback === 'function')
            errorCallback(
              e?.response?.data?.message || 'Failed to force a tick',
            );
        }
        unsubscribe();
      });
    } catch (e) {
      if (typeof errorCallback === 'function')
        errorCallback('Failed to force a tick');
    }
  };
};

export default forceSimulationAgentTick;
